import { GameWinLineProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameWinLineProperties";
export class WinLinePortraitProperties extends GameWinLineProperties {
    constructor() {
        super();
        this.position.set(34, 1441);
        this.distances = [198, 383, 566, 752, 950];
        this.expansion = 212;
        this.whiteThickness = 6;
        this.glowThickness = 16;
    }
}
//# sourceMappingURL=WinLinePortraitProperties.js.map